export default {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    padding: '6px',
  },
  title: {
    fontSize: '14px',
    padding: '8px',
  },
  button: {
    padding: '8px',
    cursor: 'pointer',
    display: 'flex',
    marginLeft: '6px',
    transition: 'background-color .2s ease',
    border: '1px solid transparent',
    '&:hover': {
      backgroundColor: 'hsla(0, 0%, 0%, 0.10)',
    },
    '&:active': {
      backgroundColor: 'hsla(0, 0%, 0%, 0.20)',
    },
  },
  buttonIcon: {
    width: '18px',
    height: '18px',
    display: 'flex',
  },
  active: {
    border: '1px dashed hsla(0, 0%, 0%, 0.20)',
  },
  inactive: {
    pointerEvents: 'none',
    backgroundColor: 'hsla(0, 0%, 0%, 0.20)',
    position: 'relative',
    '&:before': {
      content: '""',
      left: '50%',
      width: '1px',
      top: 0,
      height: '100%',
      display: 'block',
      position: 'absolute',
      background: 'black',
      transform: 'rotate(45deg)',
      cursor: 'wait',
    },
  },
}



// WEBPACK FOOTER //
// ./src/Components/DrawMap/components/DrawMapControls/styles.js